import React, { useEffect, useState } from "react";
import { LockOpen } from "@mui/icons-material";
import TextField from "@mui/material/TextField";
import { toast } from "react-toastify";
import { FraudBlock } from "../../../../types/fraud.types";
import { getFraudBlocksEffect, unblockFraudEffect } from "../../../../stores/FraudBlocksStore/FraudBlocksStore.effects";
import SimpleModal from "../../../../components/SimpleModal/SimpleModal";
import { Colors } from "../../../../constants/Colors";

interface Props {
  block: FraudBlock;
}

const UnblockUser: React.FC<Props> = ({ block }: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [notes, setNotes] = useState<string>("");

  useEffect(() => {
    if (!open) return;

    const unsubscribeDone = unblockFraudEffect.doneData.watch(() => {
      toast.success("CPF desbloqueado com sucesso!");
      setOpen(false);
      setNotes("");
      getFraudBlocksEffect();
    });
    const unsubscribeFail = unblockFraudEffect.fail.watch(({ error }: any) => {
      console.log("Error Unblock Fraud", error);
      toast.error("Erro ao desbloquear CPF!");
    });

    return () => {
      unsubscribeFail();
      unsubscribeDone();
    };
  }, [open]);

  const handleUnblock = () => {
    unblockFraudEffect({ cpf: block.cpf, notes: notes.trim() });
  };

  return (
    <SimpleModal
      open={open}
      setOpen={setOpen}
      onClose={() => setNotes("")}
      Component={
        <LockOpen
          sx={{
            color: Colors.secondary[100],
            ":hover": { opacity: "70%" },
            cursor: "pointer",
          }}
        />
      }
      onConfirm={handleUnblock}
      title="Desbloquear"
      text="Confirma desbloquear este CPF?"
      body={
        <TextField
          label="Motivo"
          placeholder="Descreva o motivo do desbloqueio"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          fullWidth
          multiline
          minRows={2}
          sx={{ mt: 1 }}
        />
      }
      confirmText="Desbloquear"
      cancelText="Cancelar"
    />
  );
};

export default UnblockUser;
